import { render, staticRenderFns } from "./OverlayListComponent.vue?vue&type=template&id=2d54c340&scoped=true"
import script from "./OverlayListComponent.vue?vue&type=script&lang=js"
export * from "./OverlayListComponent.vue?vue&type=script&lang=js"
import style0 from "./OverlayListComponent.vue?vue&type=style&index=0&id=2d54c340&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d54c340",
  null
  
)

export default component.exports